import React from "react"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"

import { Table, Icon } from "antd"

class DoubtList extends React.Component {
  componentDidMount() {}

  renderTable = () => {
    const { doubts } = this.props

    const tableData = doubts
      ? doubts.map((d) => {
          return {
            id: d.id,
            description: d.description,
            subject: d.subject && d.subject.name,
            chapter: d.chapter && d.chapter.name,
            files: d.attached_files && d.attached_files.length,
          }
        })
      : []

    const columns = [
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        render: (value, record) => (
          <div>
            {record.files > 0 && <Icon type="paper-clip" />} {value}
          </div>
        ),
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
      },
      {
        title: "Chapter",
        dataIndex: "chapter",
        key: "chapter",
      },
      // {
      //   title: "Files",
      //   dataIndex: "files",
      //   key: "files",
      //   render: (v) => {
      //     if (v > 0) {
      //       return `${v} ${v > 1 ? "files" : "file"} attached`
      //     }
      //     return "No file attached"
      //   },
      // },
    ]

    return (
      <Table
        bordered
        dataSource={tableData}
        columns={columns}
        onRow={(record) => {
          return {
            onClick: () => {
              this.props.history.push(`/doubts/${record.id}`)
            },
          }
        }}
      />
    )
  }

  render() {
    return (
      <div>
        <h1>{this.props.headingText}</h1>
        {this.renderTable()}
      </div>
    )
  }
}

export default withRouter(view(DoubtList))
